import MuiTableCell from './MuiTableCell'
import MuiTableRow from './MuiTableRow'

export default {
  MuiTableCell,
  MuiTableRow,
}
